import React from "react"

const FieldLabel = ({ children }) => (
  <dd className="text-xs text-muted-foreground uppercase mb-2">{children}</dd>
)

export default FieldLabel
